<template>
  <div class="mt-4">
    <div class="row">
      <!-- ANC Clinic -->
      <div class="col-lg-3 mb-4">
        <div
          class="card shadow h-100 clinic-card"
          @click="goToClinic('/mch/anc_list')"
        >
          <div
            class="card-body d-flex flex-column justify-content-center align-items-center text-center"
          >
            <div class="clinic-icon mb-3">🤰</div>
            <h5 class="card-title mb-0">ANC Clinic</h5>
          </div>
        </div>
      </div>

      <!-- PNC Clinic -->
      <div class="col-lg-3 mb-4">
        <div
          class="card shadow h-100 clinic-card"
          @click="goToClinic('/mch/pnc_list')"
        >
          <div
            class="card-body d-flex flex-column justify-content-center align-items-center text-center"
          >
            <div class="clinic-icon mb-3">👩‍🍼</div>
            <h5 class="card-title mb-0">PNC Clinic</h5>
          </div>
        </div>
      </div>

      <!-- Maternity -->
      <div class="col-lg-3 mb-4">
        <div
          class="card shadow h-100 clinic-card"
          @click="goToClinic('/mch/maternity')"
        >
          <div
            class="card-body d-flex flex-column justify-content-center align-items-center text-center"
          >
            <div class="clinic-icon mb-3">🏥</div>
            <h5 class="card-title mb-0">Maternity</h5>
          </div>
        </div>
      </div>

      <!-- Child Welfare -->
      <div class="col-lg-3 mb-4">
        <div
          class="card shadow h-100 clinic-card"
          @click="goToClinic('/mch/cwc')"
        >
          <div
            class="card-body d-flex flex-column justify-content-center align-items-center text-center"
          >
            <div class="clinic-icon mb-3">🧒</div>
            <h5 class="card-title mb-0">Child Welfare</h5>
          </div>
        </div>
      </div>

      <!-- Family Planning -->
      <div class="col-lg-3 mb-4">
        <div
          class="card shadow h-100 clinic-card"
          @click="goToClinic('/mch/family_planning')"
        >
          <div
            class="card-body d-flex flex-column justify-content-center align-items-center text-center"
          >
            <div class="clinic-icon mb-3">💍</div>
            <h5 class="card-title mb-0">Family Planning</h5>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MCHClinicsMenu",
  methods: {
    goToClinic(route) {
      this.$router.push(route);
    },
  },
};
</script>

<style scoped>
.clinic-card {
  cursor: pointer;
  transition: all 0.25s ease-in-out;
}
.clinic-card:hover {
  transform: translateY(-5px);
  border-color: #007bff;
  background-color: rgba(247, 202, 202, 0.5);
}
.clinic-icon {
  font-size: 3rem;
}
</style>
